export const LOADING = 'LOADING';
export type LOADING = typeof LOADING;
